import { type ReactNode } from "react";
import Header from "../../components/Header";
import { useSubscriptionGuard } from "../../hooks/useSubscriptionGuard";
import PlanSelectionNoticeModal from "../../components/PlanSelectionNoticeModal";
import { Sidebar } from "../../components/Sidebar";
import { managerMobileNavbarData, managerSidebarData } from "../../assets/navbarData";
import { MobileNav } from "../../components/MobileNav";
import Loader from "../../components/Loader";


interface LayoutProps {
  children: ReactNode;
}

export default function ManagerLayout({ children }: LayoutProps) {
    const { expired, hasSubscription, loading } = useSubscriptionGuard();

    if(loading) {
        return (
            <div className="min-h-screen flex gap-5 flex-col items-center justify-center">
                <Loader />
                <p className="text-2xl">Checking your subscription status</p>
            </div>
        );
    } else {
        if(!hasSubscription) {
            return (<PlanSelectionNoticeModal subscriptionStatus="unsubscribed"/>)
        }
    
        if(expired) {
            return (<PlanSelectionNoticeModal subscriptionStatus="expired"/>)
        }
    
        return (
            <div className="min-h-screen flex">
                {/* Desktop Sidebar */}
                <aside className="hidden md:flex w-64 h-screen fixed left-0 top-0 border-r bg-white">
                    <Sidebar data={managerSidebarData} />
                </aside>
    
                {/* Main Content */}
                <main className="flex flex-col md:ml-64 w-full justify-center p-8 md:p-10">
                    <Header />
                    <div className="flex-1 my-8">
                        {children}
                    </div>
                </main>
    
                {/* Mobile Navbar */}
                <div className="md:hidden fixed bottom-0 left-0 w-full border-t bg-white">
                    <MobileNav data={managerMobileNavbarData} />
                </div>
            </div>
        );
    }
}
